import { azureScopes } from '@/app.azure';
import { StoreState } from '@/store';
import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { exhaustMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AddTokenService {

  constructor(
    private msalAuthService: MsalService,
    private store: Store<StoreState>,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const currentAccount = this.msalAuthService.instance.getAllAccounts()[0];

    const accessTokenRequest = {
      scopes: azureScopes,
      account: currentAccount,
    };

    return this.msalAuthService.acquireTokenSilent(accessTokenRequest).pipe(
      exhaustMap((tokenData) => {
        localStorage.setItem('token', tokenData.accessToken);

        const authReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${tokenData.accessToken}`,
            AzureTokenAd: tokenData.accessToken,
          },
        });

        return next.handle(authReq);
      }),
    );
  }
}
